import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ compact = false }) => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div
      className={`language-switcher ${compact ? 'compact' : ''}`}
      role="group"
      aria-label={t('Language')}
    >
      <button
        type="button"
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => setLanguage('en')}
        title={t('English')}
        aria-pressed={language === 'en'}
      >
        EN
      </button>
      <button
        type="button"
        className={`lang-btn ${language === 'nl' ? 'active' : ''}`}
        onClick={() => setLanguage('nl')}
        title={t('Dutch')}
        aria-pressed={language === 'nl'}
      >
        NL
      </button>
    </div>
  );
};

export default LanguageSwitcher;
